// LastUpdated — "обновлено N назад" freshness badge for list screens
// (docs/miniapp-m7-tz.md §3.7). Pass React Query's `dataUpdatedAt`; the label
// is relative ("только что" / "5 мин назад" / "1 ч назад") and re-ticks every
// 30s so it ages without a refetch. Color-coded by freshness: <1 min green,
// ≤30 min neutral, >30 min muted.
import { useEffect, useState } from 'react'

import { t } from '../design'

export function LastUpdated({ at }: { at?: number }) {
  // Force a re-render on an interval so the relative label stays current.
  const [, tick] = useState(0)
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 30_000)
    return () => clearInterval(id)
  }, [])

  if (!at) return null

  const mins = Math.floor((Date.now() - at) / 60_000)
  const label =
    mins < 1 ? t('upd.justNow')
    : mins < 60 ? t('upd.minAgo', { n: mins })
    : t('upd.hourAgo', { n: Math.floor(mins / 60) })
  const color = mins < 1 ? 'var(--success)' : mins > 30 ? 'var(--text-3)' : 'var(--text-2)'

  return (
    <span className="t-caption" style={{ color, whiteSpace: 'nowrap' }}>
      {t('upd.prefix')} {label}
    </span>
  )
}
